<template>
  <!-- 新闻详情页 -->
  <div class="news-detail bg-white">
    <div class="container">
      <div class="page-padding" />
      <Breadcrumb class="mt-1" :list="breadcrumbList" />
      <div class="container-content">
        <el-skeleton :rows="10" v-if="loading" animated />
        <div v-else>
          <el-empty v-if="isError && !loading" style="min-height: 280px">
            <template #image>
              <el-icon class="fs-large text-black-2"><FolderDelete /></el-icon>
            </template>
            <template #description>
              <div style="fs-xxxl">新闻内容不存在或已被删除</div>
            </template>
          </el-empty>
          <template v-else>
            <h1 class="text-center fs-large fw-500 mb-5">{{ news.title }}</h1>
            <div class="text-right fs-lg text-dark-1 mb-3">
              <span class="ml-2" v-if="news.source">
                来源:
                {{ news.source }}
              </span>
              <span class="ml-2">
                发布时间:
                {{ news.publishTime }}
              </span>
            </div>
            <div class="mb-6 indent text-justify l-h-1-8">
              <div v-html="news.content"></div>
            </div>
          </template>
        </div>
      </div>
      <div class="page-padding" />
    </div>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue'
import { useRoute } from 'vue-router'
import { FolderDelete } from '@element-plus/icons-vue'

import Breadcrumb from '@/components/breadcrumb/index.vue'

import { parseTime } from '@/utils'
import { newsDetail } from '@/api/news.js'
import { setPV } from '@/api/config.js'

const route = useRoute()
const breadcrumbList = ref([
  {
    name: '新闻纵览',
    to: { path: '/news' }
  },
  {
    name: '详情'
  }
])

const loading = ref(true)
const isError = ref(false)

const news = ref(null)
const id = ref(route.params.id)

onMounted(async () => {
  getNews()
  await setPV()
})

const getNews = async () => {
  loading.value = true
  if (!id.value) {
    isError.value = true
    loading.value = false
    return
  }
  const res = await newsDetail(id.value)
  res.publishTime = parseTime(res.publishTime)
  news.value = res
  breadcrumbList.value[1].name = news.value.title
  loading.value = false
}
</script>

<style lang="scss" scoped></style>
